export default __webpack_public_path__ + "static/speaking-hero-505e2afb0d4bb15bec5e586d00183010.png";